import axios from 'axios';
import { API_BASE_URL } from 'config';

const instance = axios.create({
  baseURL: API_BASE_URL,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  config.headers.authorization = token;
  return config;
});

export default instance;
